export function openInNewWindow(
  url: string,
  features = `
    toolbar=no,
    location=no,
    status=no,
    menubar=no,
    scrollbars=yes,
    resizable=yes,
    width=800,
    height=600
  `
): void {
  window.open(url, 'targetWindow', features);
}
